import { Dispatch, SetStateAction, useCallback } from 'react'
import { StoreCalendarType } from 'types/storeCalendar'

const useSelectStoreCalendar = (
  update: Dispatch<SetStateAction<StoreCalendarType[]>>,
  setIsEdited?: Dispatch<SetStateAction<boolean>>
) => {
  return useCallback(
    (value: StoreCalendarType) => {
      update((prevState) => {
        const index = prevState.findIndex((state) => state.date === value.date)

        // リストに存在しない場合は追加
        if (index === -1) {
          if (value.status === '') {
            return prevState
          } else {
            return [...prevState, value]
          }
          // リストに存在する場合は更新
        } else {
          prevState[index] = { ...value }
          return [...prevState]
        }
      })
      setIsEdited && setIsEdited(true)
    },
    [update, setIsEdited]
  )
}

export default useSelectStoreCalendar
